import "../../../styles/Colors.css";
import "../styles/CalendarStyle.css";
import "../../../styles/Fonts.css";
import "../../../styles/Buttons.css";
import AddfromCalen from "./AddfromCalen";
import { baseURL, useFetch } from "../../../custom/api";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import persian_fa from "react-date-object/locales/persian_fa.js";
import persian from "react-date-object/calendars/persian.js";
import persian_fa from "react-date-object/locales/persian_fa.js";
// import gregorian from "react-date-object/locales/gregorian_en.js";
import DateObject from "react-date-object";
// var  = require("date-object/calendars/cjs/gregorian");



const options = [
  { breakfast: "صبحانه", snack1: "میانوعده صبح" },
  {
    lunch: "نهار",
    snack2: "میانوعده عصر",
  },
  {
    dinner: "شام",
    snack3: "میانوعده شب",
  },
];

let locations = {
  breakfast: 0,
  snack1: 0,
  lunch: 1,
  snack2: 1,
  dinner: 2,
  snack3: 2,
};

function Week({ week }) {
  const [calendarData, setCalendarData] = useState([]);
  let startDate = new Date(week[0].convert()).toISOString().substring(0, 10);
  let endDate = new Date(week[6].convert()).toISOString().substring(0, 10);

  const { myFetch } = useFetch();

  useEffect(() => {
    const fetchData = async () => {
      let body = { start_date: startDate, end_date: endDate };
      const resp = await myFetch(`calendar/get`, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(body),
      });
      const r = await resp.json();
      setCalendarData(r);
    };
    fetchData();
  }, []);

  return week.map((elem) => {
    let className;
    let today = new DateObject({
      date: new Date(),
      locale: persian_fa,
    });

    // console.log(myDay.setCalendar(persian).format("dddd DD MMMM"));

    if (
      elem.setCalendar(persian).format("dddd DD MMMM") ===
      today.setCalendar(persian).format("dddd DD MMMM")
    ) {
      className = "marginBottom1 rightAlign today-date";
    } else {
      className = "marginBottom3 rightAlign";
    }

    return (
      <div className={className} key={Math.random()}>
        <div className="heading-2 paddingSide5 paddingTop1 marginBottom8p spc-between centerItemAlign">
          {elem.setCalendar(persian).format("dddd DD MMMM")}
          {/* <Link to="/cards" className="icon-iconplus purple-1 heading-2"></Link> */}
        </div>
        <div className="meals-body">
          {options.map((element) => {
            let mealTypes = Object.keys(element);
            return (
              <div className="" key={Math.random()}>
                {mealTypes.map((mealType) => {
                  let farsiMealType = options[locations[mealType]][mealType];
                  let recipeInfo = calendarData.filter((calendarElem) => {
                    return (
                      calendarElem.date ===
                        new Date(elem.convert()).toISOString().substring(0, 10) &&
                      calendarElem.meal_type === mealType
                    );
                  })[0];

                  return (
                    <>
                      {
                        recipeInfo ? (
                          // render if variable is not null
                          <AddfromCalen
                            title={farsiMealType}
                            mealType={mealType}
                            image={
                              recipeInfo?.image_path &&
                              `${baseURL}/${recipeInfo.image_path}`
                            }
                            name={recipeInfo?.recipe_name}
                            recipeId={recipeInfo?.recipe_id}
                            date={recipeInfo?.date}
                            calendarData={calendarData}
                            setCalendarData={setCalendarData}
                            calendarId={recipeInfo?.calendar_id}
                            key={Math.random()}
                          />
                        ) : // render if variable is null
                        null
                        // <span className="icon-iconplus heading-2 grey-3"></span>
                      }
                    </>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  });
}
export default Week;
